<template>
    <div class="resource-center-rule">
        <!-- resource center module picker -->
        <div :class="{ 'guide-undefined': rule.guideDeleted }">
            <pendo-multiselect
                :value="rule.guide"
                :allow-empty="false"
                :options="modulesForResourceCenter"
                :searchable="true"
                :disabled="readOnly"
                label-key="name"
                value-key="id"
                full-width
                :extra-label-width="60"
                placeholder="Select Module"
                class="resource-center-rule--rc-module-select"
                @select="onGuideSelect" />
            <rule-warning v-if="rule.guideDeleted">
                The original module for this rule has been deleted
            </rule-warning>
        </div>
        <operator-picker
            :rule="rule"
            v-bind="$attrs" />
        <disabled-single-option-select
            v-if="showCosmeticEver"
            option="ever" />
    </div>
</template>

<script>
import get from 'lodash/get';
import { PendoMultiselect } from '@pendo/components';
import OperatorPicker from '@/segments/components/segment-editor-vue/adopt-segment-builder/rule-components/operator-picker.vue';
import RuleWarning from '@/segments/components/segment-editor-vue/adopt-segment-builder/rule-components/rule-warning.vue';
import DisabledSingleOptionSelect from '@/segments/components/segment-editor-vue/adopt-segment-builder/rule-components/disabled-single-option-select.vue';
import ReadOnlyMixin from '@/segments/components/segment-editor-vue/adopt-segment-builder/rule-mixins/read-only.mixin';

export default {
    name: 'ResourceCenterRule',
    components: {
        DisabledSingleOptionSelect,
        OperatorPicker,
        PendoMultiselect,
        RuleWarning,
    },
    mixins: [ReadOnlyMixin],
    props: {
        computedData: {
            type: Object,
            required: true,
        },
        rule: {
            type: Object,
            required: true,
        },
    },
    emits: ['input'],
    computed: {
        modulesForResourceCenter () {
            const { rule } = this;
            const { app } = rule;
            const appId = get(app, 'id');
            const homeViewId = get(this.computedData.draftResourceCentersMap, `${appId}.homeView.id`);

            return this.computedData.rcModules
                .filter((guide) => {
                    const resourceCenterId =
                        get(guide, 'attributes.resourceCenter.homeViewId') ||
                        get(guide, 'attributes.resourceCenter.originId');

                    return resourceCenterId === homeViewId;
                })
                .map((guide) => {
                    const isHomeView = get(guide, 'attributes.resourceCenter.isTopLevel');

                    return Object.assign(guide, {
                        guideId: guide.id, // can't be named moduleId because guidesSeenEver source only accepts 'guideId'
                        name: isHomeView ? 'Resource Center Home' : guide.name,
                    });
                });
        },
        showCosmeticEver () {
            const { rule } = this;
            const operatorValue = get(rule, 'operator.value');

            return ['viewed', 'notviewed'].includes(operatorValue);
        },
    },
    methods: {
        onGuideSelect (guide) {
            this.$emit('input', [
                { field: 'guide', value: guide },
                { field: 'guideDeleted', value: false },
            ]);
        },
    },
};
</script>

<style lang="scss" scoped>
.resource-center-rule {
    display: contents;

    .guide-undefined {
        :deep(.pendo-multiselect__trigger) {
            border: 1px solid var(--palette-red-50);
        }
    }
}
</style>
